// src/components/Admin/ChatManager/index.jsx

import { Box, Typography } from '@mui/material';
import { useUser } from '../../../contexts/UserContext';
import ChatCategoryManager from './ChatCategoryManager';

const ChatManager = () => {
    const { userInfo } = useUser();
    const isAdmin = userInfo?.role === 'admin' || userInfo?.role === 'master';

    if (!isAdmin) {
        return (
            <Box
                sx={{
                    p: 4,
                    '@media (max-width:600px)': {
                        p: 2,
                    },
                }}
            >
                <Typography
                    color="error"
                    variant="h6"
                    sx={{
                        '@media (max-width:600px)': {
                            fontSize: '1rem',
                        },
                    }}
                >
                    ⚠️ 이 페이지에 접근할 수 있는 권한이 없습니다.
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                p: 4,
                '@media (max-width:600px)': {
                    p: 2,
                },
            }}
        >
            <ChatCategoryManager />
        </Box>
    );
};

export default ChatManager;
